module.exports = __webpack_public_path__ + "img/tech_service_menue_3.a7702fd2.png";